export default {
  title: 'Components/Attach File',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-attach-file\` component, pass the following props:

\`\`\`html
<dda-attach-file
  label="Attach File"
  place_holder="No File Selected"
  upload_button_text="Choose File"
  helper_text="Helper or footer text"
  success_text="Successfully uploaded"
  error_message="Error message"
  file_size_error_message="File size should not exceed {max} MB"
  max_file_size="2"
  size="default"
  validation_type="normal"
  input_type="normal"
  custom_class=""
  component_mode=""
  input_id="input"
  button_id="button"
  delete_button_id="deleteFile"
  aria_label="input"
  button_aria_label="button"
  button_name="button"
  input_name="input"
  accept=".pdf,.docx"
></dda-attach-file>
\`\`\`

The component emits a \`fileChanged\` event when a file is selected or removed.
        `,
      },
    },
  },

  argTypes: {
    label: { control: 'text', description: 'Label for the attach file component' },
    place_holder: { control: 'text', description: 'Default place holder text' },
    upload_button_text: { control: 'text', description: 'Button text for upload file' },
    helper_text: { control: 'text', description: 'Helper text for the attach file component' },
    success_text: { control: 'text', description: 'Success message text' },
    error_message: { control: 'text', description: 'Error message displayed below the component' },
    file_size_error_message: { control: 'text', description: 'File size limit exceed warning message. Use {max} as a placeholder for max size' },
    validation_id: { control: 'text', description: 'ID used for error/helper message' },
    size: {
      control: { type: 'select' },
      options: ['default', 'small'],
      description: 'Size of the attach file component',
    },
    validation_type: {
      control: { type: 'select' },
      options: ['normal', 'error'],
      description: 'Validation type of the component',
    },
    input_type: {
      control: { type: 'select' },
      options: ['normal', 'disabled'],
      description: 'Input type (used for visual class only)',
    },
    custom_class: { control: 'text', description: 'Custom class to be applied' },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the attach file component',
    },
    input_id: { control: 'text', description: 'Input id for file input' },
    button_id: { control: 'text', description: 'Button id for file upload button' },
    delete_button_id: { control: 'text', description: 'Button id for file delete button' },
    aria_label: { control: 'text', description: 'ARIA label for input' },
    button_aria_label: { control: 'text', description: 'ARIA label for upload button' },
    button_name: { control: 'text', description: 'Name for the upload button' },
    input_name: { control: 'text', description: 'Name for the input field' },
    accept: { control: 'text', description: 'Accept attribute for file types (e.g., .pdf,.docx)' },
    max_file_size: { control: 'number', description: 'Maximum file size allowed in MB' },
  },
};

const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => {
      if (typeof value === 'boolean') return value ? key : '';
      return `${key}="${value}"`;
    })
    .filter(Boolean)
    .join(' ');

  return `
    <dda-attach-file ${attributes}></dda-attach-file>
    <script>
      const fileComponent = document.querySelector('dda-attach-file');
      fileComponent?.addEventListener('fileChanged', (e) => {
        console.log('fileChanged:', e.detail);
      });
    </script>
  `;
};

export const Default = Template.bind({});
Default.args = {
  label: 'Attach File',
  place_holder: 'No File Selected',
  upload_button_text: 'Choose File',
  helper_text: 'Helper or footer text',
  success_text: 'Successfully uploaded',
  error_message: 'Error Message',
  validation_id: 'validationId',
  file_size_error_message: 'File size should not exceed {max} MB',
  max_file_size: 200,
  size: 'default',
  validation_type: 'normal',
  input_type: 'normal',
  input_id: 'choose-File',
  button_id: 'choose-File-button',
  delete_button_id: 'delete-File-button',
  aria_label: 'input',
  button_aria_label: 'button',
  button_name: 'button',
  input_name: 'input',
  accept: '.pdf,.docx',
  custom_class: '',
  component_mode: '',
  onInput: '',
};

export const Small = Template.bind({});
Small.args = {
  ...Default.args,
  size: 'small',
};

export const ErrorState = Template.bind({});
ErrorState.args = {
  ...Default.args,
  validation_type: 'error',
};

export const Disabled = Template.bind({});
Disabled.args = {
  ...Default.args,
  input_type: 'disabled',
};
